<template>
	<div id="data-list-list-view" class="data-list-container">
		<vs-table ref="table" pagination :max-items="itemsPerPage" search :data="listStatusMobile">
			<template slot="thead">
				<vs-th
					v-if="validateColumn('name')"
					sort-key="category"
					v-text="$t('StatusMobile.StatusMobileName')"
				></vs-th>
				<vs-th
					v-if="validateColumn('description')"
					class="g-table--title"
					sort-key="name"
					v-text="$t('StatusMobile.ListStatusMobile.Description')"
				></vs-th>
				<vs-th
					v-if="validateColumn('active_event')"
					sort-key="name"
					v-text="$t('StatusMobile.ListStatusMobile.ActiveEvent')"
				></vs-th>
				<vs-th
					v-if="validateColumn('active_event')"
					sort-key="name"
					v-text="$t('StatusMobile.ListStatusMobile.ZoneRequired')"
				></vs-th>
				<vs-th
					v-if="validateColumn('status_id')"
					class="g-table--title"
					sort-key="name"
					v-text="$t('StatusMobile.ListStatusMobile.Status')"
				></vs-th>
				<vs-th
					class="g-table--title"
					v-if="(statusMobileUpdatePermission || statusMobileDeletePermission) && validateColumn('action')"
				>
					{{ $t("Action") }}
				</vs-th>
			</template>
			<template slot-scope="{data}">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td v-if="validateColumn('name')">
							<p class="product-name g-table--description truncate">{{ tr.name }}</p>
						</vs-td>
						<vs-td v-if="validateColumn('description')">
							<p class="product-category g-table--description">{{ tr.description }}</p>
						</vs-td>
						<vs-td v-if="validateColumn('active_event')">
							<vs-chip v-if="tr.active_event" transparent color="success">
								<span class="text-center" v-text="$t('StatusMobile.ListStatusMobile.Active')"></span>
							</vs-chip>
							<vs-chip v-else transparent color="danger">
								<span class="text-center" v-text="$t('StatusMobile.ListStatusMobile.Disabled')"></span>
							</vs-chip>
						</vs-td>
						<vs-td v-if="validateColumn('active_event')">
							<vs-chip v-if="tr.zone_required" transparent color="success">
								<span class="text-center" v-text="$t('StatusMobile.ListStatusMobile.Active')"></span>
							</vs-chip>
							<vs-chip v-else transparent color="danger">
								<span class="text-center" v-text="$t('StatusMobile.ListStatusMobile.Disabled')"></span>
							</vs-chip>
						</vs-td>
						<vs-td v-if="validateColumn('status_id')">
							<p class="product-category g-table--description">{{ status_name(tr.status_id) }}</p>
						</vs-td>
						<vs-td
							class="whitespace-no-wrap g-table--description"
							v-if="
								(statusMobileUpdatePermission || statusMobileDeletePermission) &&
								validateColumn('action')
							"
						>
							<feather-icon
								v-if="statusMobileUpdatePermission"
								icon="Edit2Icon"
								svgClasses="w-5 h-5 hover:text-primary stroke-current"
								class="g-label--normal"
								@click.stop="editData(tr)"
							/>
							<feather-icon
								v-if="statusMobileDeletePermission"
								icon="Trash2Icon"
								svgClasses="w-5 h-5 hover:text-danger stroke-current"
								class="ml-2 g-label--normal"
								@click.stop="openConfirm(tr.id)"
							/>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
import moduleStatusMobile from "@/store/status-mobile/moduleStatusMobile.js";

export default {
	name: "StatusMobileListView",
	props: {
		listConfiguration: {
			type: Object,
			default: () => {
				return {
					columns: ["name", "description", "active_event", "status_id", "action", "enable_status_resource"],
					action: true,
					multiple: false,
				};
			},
		},
	},
	data() {
		return {
			itemsPerPage: 10,
			isMounted: false,
			itemSelected: null,
			statusActive: {},
		};
	},
	computed: {
		validateColumn() {
			return function (columnName) {
				return this.listConfiguration.columns.find((column) => column === columnName);
			};
		},
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.listStatusMobile.length;
		},
		// lista de status mobile
		listStatusMobile() {
			return this.$store.state.moduleStatusMobile.statusMobile;
		},
		// lista de status
		listStatus() {
			return this.$store.state.moduleStatusMobile.status;
		},
		// lista de empresas
		listCompanies() {
			return this.$store.state.moduleStatusMobile.companies;
		},
		statusMobileUpdatePermission() {
			return this.$store.getters.checkPermission("STATUSMOBILE_U");
		},
		statusMobileDeletePermission() {
			return this.$store.getters.checkPermission("STATUSMOBILE_D");
		},
		status_name() {
			return function (status_id) {
				const found = this.listStatus.find((statu) => statu.id === status_id);
				if (found) {
					return found.name;
				}
				return "";
			};
		},
	},
	methods: {
		// seleccion editar
		editData(data) {
			// Emite un evento al padre "StatusMobile.vue", enviando la información del Estado
			this.$emit("selectedStatusMobileEmit", data);
		},
		// Click en icono eliminar
		openConfirm(id) {
			this.itemSelected = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("StatusMobile.FormStatusMobile.Delete.Text"),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
				accept: this.acceptAlert,
			});
		},
		// Se acepta la eliminación
		acceptAlert() {
			this.deleteData(this.itemSelected);
		},
		// Elimina el status mobile
		deleteData(id) {
			this.$vs.loading();
			// Llama la accion Vuex, "removeRole" y se le envia el id del rol
			this.$store
				.dispatch("moduleStatusMobile/removeStatus", id)
				.then((res) => {
					// Respuesta exitosxa
					// cierra load
					this.$vs.loading.close();
					// Muestra mensaje de respuesta exitoso
					this.$vs.notify({
						color: "success",
						title: this.$t("StatusMobile.FormStatusMobile.Delete.Success.Title"),
						text: this.$t("StatusMobile.FormStatusMobile.Delete.Success.Text"),
					});
				})
				.catch((err) => {
					// Muestra mensaje de respta erroneo
					this.$vs.notify({
						color: "danger",
						title: this.$t("StatusMobile.FormStatusMobile.Delete.Error.Title"),
						text: this.$t("StatusMobile.FormStatusMobile.Delete.Error.Text"),
					});
					throw new Error(err);
				});
		},
	},
	mounted() {
		this.isMounted = true;
	},
	created() {
		// Se registra el modulo
		if (!moduleStatusMobile.isRegistered) {
			this.$store.registerModule("moduleStatusMobile", moduleStatusMobile);
			moduleStatusMobile.isRegistered = true;
		}
	},
};
</script>

<style lang="scss" scoped>
#data-list-list-view {
	.vs-con-table {
		/*
          Below media-queries is fix for responsiveness of action buttons
          Note: If you change action buttons or layout of this page, Please remove below style
        */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;

			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

				td {
					padding: 20px;

					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}

					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}

				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}

			th.td-check {
				padding: 0 15px !important;
			}

			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}

		.vs-con-tbody {
			background: #ffffff;
			box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
			border-radius: 10px;
		}
	}
}
</style>
